import Link from '@alltrails/denali/components/Link';
import { FormattedMessage } from 'react-intl';
import Typography from '@alltrails/core/components/Typography';
import styles from '../../../components/OldPressCard/styles/styles.module.scss';
import { OldPressReleaseCard } from '@/components/OldPressCard';

const alltrailsLink = (
  <Link href="/" target="_blank">
    AllTrails
  </Link>
);

const allTrailsDotComLink = (
  <Link href="/" target="_blank">
    AllTrails.com
  </Link>
);

const iphoneAppOfTheYear = (
  <Link href="https://www.apple.com/newsroom/2023/11/apple-unveils-app-store-award-winners-the-best-apps-and-games-of-2023/" target="_blank">
    <FormattedMessage defaultMessage="iPhone App of the Year" />
  </Link>
);

const pressRelease: OldPressReleaseCard = {
  cardType: 'press-release',
  title: <FormattedMessage defaultMessage="AllTrails Introduces Collaborative Lists" />,
  date: 'February 15 2024',
  modalContent: (
    <>
      <Typography variant="heading400" component="h2">
        <FormattedMessage defaultMessage="AllTrails Introduces Collaborative Lists" />
      </Typography>

      <Typography variant="heading200" component="h3">
        <FormattedMessage defaultMessage="A new way to share, plan, and explore the platform’s extensive collection of curated trails" />
      </Typography>

      <Typography variant="paragraph100">
        <FormattedMessage
          defaultMessage="Just in time for spring and summer planning, {alltrailsLink}, the world's largest and most trusted outdoor platform, launched Collaborative Lists, the latest addition to the brand’s suite of online and in-app features. With Collaborative Lists, users can build trail wish lists with friends and family, making for a fun, interactive way to plan adventures with trail and travel companions. The addition helps AllTrails’ global community of more than 60 million outdoor enthusiasts more easily coordinate spending time outside with others."
          values={{ alltrailsLink }}
        />
        <br />
        <FormattedMessage defaultMessage="Collaborative Lists expands on AllTrails’ Saved Lists feature by allowing friends to share ideas and make plans together. Whether considering hikes for a family trip, or creating a group bucket list for the year, now all trail-goers can have a say when it comes to planning future adventures." />
        <br />
        <FormattedMessage defaultMessage="“We love seeing our community share their love of the outdoors with others,” said Ron Schneidermann, Chief Executive Officer at AllTrails. “With Collaborative Lists, we’re making it even easier for our members to get inspired, plan experiences, and get outside with friends and family.”" />
        <br />
        <FormattedMessage defaultMessage="To use Collaborative Lists, AllTrails users can start a list and ‘invite collaborators’ to add their ideas. AllTrails members can share these lists with fellow AllTrails users and non-users alike. The new feature is free to everyone." />
        <br />
        <FormattedMessage
          defaultMessage="With a global community of over 60 million trail-goers and over 420 thousand trails, AllTrails continues to be the most recognized digital brand and category leader in the outdoor activity sector. In 2023 — a high-growth year for the San Francisco-based company — AllTrails was awarded {iphoneAppOfTheYear} by Apple, celebrating its outstanding approach to helping people explore the outdoors. In addition to this recent recognition, AllTrails is frequently featured as a 'Top 5 Health & Fitness App.'"
          values={{ iphoneAppOfTheYear }}
        />
        <br />
        <FormattedMessage defaultMessage="About AllTrails" />
        <br className={styles.noMargin} />
        <FormattedMessage
          defaultMessage="AllTrails helps you find your way outside with detailed reviews and inspiration from a global community of trail-goers. Every day, AllTrails is inspired to help get more people outside so they can have healthy, authentic experiences and a deeper appreciation of the outdoors. AllTrails was awarded Apple’s 2023 iPhone App of the Year and a Google Play Best of 2023 honorable mention. Download AllTrails in the App Store or head to {allTrailsDotComLink} to learn more."
          values={{ allTrailsDotComLink }}
        />
      </Typography>
    </>
  )
};

export default pressRelease;
